// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import { IconChevronLeft } from "../components/icons.jsx";
import * as React from "react";
import * as jsxRuntime from "react/jsx-runtime";
import { IconBolt } from "../components/icons.jsx";
import { Ox } from "../assets.jsx";
import { kx } from "../assets.jsx";
import { Rx } from "../assets.jsx";
import { Bx } from "../assets.jsx";
import { Ux } from "../assets.jsx";
import { IconSparkles } from "../components/icons.jsx";
import { IconSpiral } from "../components/icons.jsx";
import { IconTrophy } from "../components/icons.jsx";
import { IconCalendar } from "../components/icons.jsx";
import { IconArrowRight } from "../components/icons.jsx";
export function SummerEventPage({
  resources: u,
  onBack: o,
  onOpenFishing: m
}) {
  const [r, g] = React.useState(() => Math.max(0, Date.UTC(2026, 8, 1) - Date.now())),
    j = window.Telegram?.WebApp?.BackButton;
  React.useEffect(() => {
    if (j) return j.show(), j.onClick(o), () => {
      j.offClick(o), j.hide();
    };
  }, [j, o]), React.useEffect(() => {
    const U = window.setInterval(() => g(Math.max(0, Date.UTC(2026, 8, 1) - Date.now())), 6e4);
    return () => window.clearInterval(U);
  }, []);
  const B = r ? `${Math.floor(r / 864e5)}д ${Math.floor(r % 864e5 / 36e5)}ч` : "Завершён";
  return jsxRuntime.jsxs("section", {
    className: "mc-summer-page",
    children: [!j && jsxRuntime.jsxs("button", {
      className: "mc-wallet-back",
      onClick: o,
      children: [jsxRuntime.jsx(IconChevronLeft, { "aria-hidden": "true" }), " Назад"]
    }), jsxRuntime.jsxs("header", {
      className: "mc-summer-heading",
      children: [jsxRuntime.jsxs("div", {
        children: [jsxRuntime.jsx("p", {
          children: "СЕЗОННОЕ ПРИКЛЮЧЕНИЕ"
        }), jsxRuntime.jsx("h1", {
          children: "Летний сезон"
        }), jsxRuntime.jsx("small", {
          children: "Острова, ракушки и древние реликвии"
        })]
      }), jsxRuntime.jsxs("strong", {
        children: [jsxRuntime.jsx(IconBolt, {}), " ", B]
      })]
    }), jsxRuntime.jsxs("section", {
      className: "mc-summer-hero",
      children: [jsxRuntime.jsx("img", {
        className: "mc-summer-hero-bg",
        src: Ox,
        alt: ""
      }), jsxRuntime.jsx("img", {
        className: "mc-summer-hero-chest",
        src: kx,
        alt: ""
      }), jsxRuntime.jsx("img", {
        className: "mc-summer-hero-foreground",
        src: Rx,
        alt: ""
      }), jsxRuntime.jsx("img", {
        className: "mc-summer-hero-palm",
        src: Bx,
        alt: ""
      }), jsxRuntime.jsx("img", {
        className: "mc-summer-hero-particles",
        src: Ux,
        alt: ""
      }), jsxRuntime.jsxs("div", {
        children: [jsxRuntime.jsxs("p", {
          children: [jsxRuntime.jsx(IconSparkles, {}), " ЛЕТО 2026 · СОБЫТИЕ"]
        }), jsxRuntime.jsxs("h2", {
          children: ["Экспедиция", jsxRuntime.jsx("br", {}), jsxRuntime.jsx("em", {
            children: "за реликвиями"
          })]
        }), jsxRuntime.jsx("small", {
          children: "Собирай ракушки и находи древние реликвии."
        })]
      }), jsxRuntime.jsxs("footer", {
        children: [jsxRuntime.jsxs("span", {
          children: [jsxRuntime.jsx("i", {
            children: jsxRuntime.jsx(IconSpiral, {})
          }), jsxRuntime.jsx("b", {
            children: u.eventCurrency.toLocaleString("ru-RU")
          }), jsxRuntime.jsx("small", {
            children: u.eventCurrencyName
          })]
        }), jsxRuntime.jsxs("span", {
          children: [jsxRuntime.jsx("i", {
            children: jsxRuntime.jsx(IconTrophy, {})
          }), jsxRuntime.jsx("b", {
            children: "0"
          }), jsxRuntime.jsx("small", {
            children: "реликвий найдено"
          })]
        }), jsxRuntime.jsxs("span", {
          children: [jsxRuntime.jsx("i", {
            children: jsxRuntime.jsx(IconCalendar, {})
          }), jsxRuntime.jsx("b", {
            children: "0"
          }), jsxRuntime.jsx("small", {
            children: "дней пути"
          })]
        })]
      })]
    }), jsxRuntime.jsx("section", {
      className: "mc-summer-section mc-summer-fishing-section",
      children: jsxRuntime.jsxs("button", {
        className: "mc-summer-activity fishing",
        onClick: m,
        children: [jsxRuntime.jsx("i", {
          children: jsxRuntime.jsx(IconSpiral, {})
        }), jsxRuntime.jsxs("span", {
          children: [jsxRuntime.jsx("b", {
            children: "Рыбалка"
          }), jsxRuntime.jsx("small", {
            children: "Лови редкую рыбу у берегов островов"
          })]
        }), jsxRuntime.jsxs("em", {
          children: ["В путь ", jsxRuntime.jsx(IconArrowRight, {})]
        })]
      })
    })]
  });
}
